import { render } from "./JoinGameByCodeModal.vue?vue&type=template&id=2959ff71"
import script from "./JoinGameByCodeModal.vue?vue&type=script&lang=js"
export * from "./JoinGameByCodeModal.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/gilcode.com/kwordz.gilcode.com/packages/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__